import angular from 'angular';
import { IGerenciamentoDocumento } from '../models/gerenciamentodocumento.model';

export class CancelarAssinaturaDocumentoModalService {

    static $inject = ['$uibModal'];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) {}

    public open(documento: IGerenciamentoDocumento): ng.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./cancelar-assinatura.modal.html'),
            controller: 'CancelarAssinaturaDocumentoModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                documento: () => angular.copy(documento),
            }
        });
    }
}
